import type { ChangeEvent, FocusEvent, MouseEvent } from "react";
import { Container, InputWrapper, IconWrapper } from "./EmailForm.styles";
import { UserIdVerificationIcon } from "src/assets/icons/user-id-verification";
import Input from "src/components/Input";
import { PrimaryButton } from "src/components/Buttons";

interface EmailFormProps {
  value: string;
  showError: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur: (event: FocusEvent<HTMLInputElement>) => void;
  onSubmit: (event: MouseEvent<HTMLButtonElement>) => void;
  loading: boolean;
}

export const EmailForm: React.FC<EmailFormProps> = ({
  value,
  showError,
  onChange,
  onFocus,
  onBlur,
  onSubmit,
  loading,
}) => (
  <Container>
    <InputWrapper>
      <Input
        value={value}
        className={showError ? "wiggle-animation" : ""}
        showError={showError}
        errorMessage="Email is invalid"
        placeholder="Email"
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        ariaLabel="email-login-input"
      />
      <IconWrapper>
        <UserIdVerificationIcon />
      </IconWrapper>
    </InputWrapper>
    <PrimaryButton
      size="large"
      width="100%"
      initialBg={true}
      onClick={onSubmit}
      loading={loading}
      disabled={showError}
    >
      Continue
    </PrimaryButton>
  </Container>
);
